angular.module('qkr').controller('TaxRatesController', ['$scope', '$rootScope',  '$uibModalInstance', 'taxService',
    'product', 'currentTaxes', function($scope, $rootScope,  $uibModalInstance, taxService, product, currentTaxes) {
	$scope.product = product;
	$scope.taxGroups = null;
    $scope.currentTaxes = currentTaxes;
	
	$scope.ok = function() {
		$uibModalInstance.close(getUpdatedTaxRates());
	};
	
	$scope.cancel = function() {
		$uibModalInstance.dismiss('cancel');
	};
	
	const getTaxRates = function() {
		taxService.getTaxRatesForCountry($rootScope.merchantInfo.contactDetails.country.id).then((defaultTaxRates) => {
			const defaultTaxGroups = defaultTaxRates;

            if ($scope.currentTaxes.length > 0) {
                angular.forEach($scope.currentTaxes, (currentTax) => {
                    for (let i = 0; i < defaultTaxGroups.length; i++) {
                        const defaultTaxGroup = defaultTaxGroups[i];
                        let found = false;

                        if (defaultTaxGroup.discriminatedValue === currentTax.discriminatedValue) {
                            // Loop through the sales taxs objects and match on id
                            for (let j = 0; j < defaultTaxGroup.taxRates.length; j++) {
                                const taxRate = defaultTaxGroup.taxRates[j];
                                if (taxRate.id === currentTax.taxRate.id) {
                                    defaultTaxGroup.selectedTaxRate = taxRate;
                                    found = true;
                                    break;
                                }
                            }

                            if (found) {
                                break;
                            }
                        }
                    }
                });

                $scope.taxGroups = defaultTaxGroups;
            } else if ($scope.product.id) {
                    taxService.getMerchantTaxRatesForInventoryItem($scope.product.id).then((explicitTaxRates) => {
                        angular.forEach(explicitTaxRates, (explicitTaxRate) => {
                            for (let i = 0; i < defaultTaxGroups.length; i++) {
                                const defaultTaxGroup = defaultTaxGroups[i];
                                let found = false;

                                if (defaultTaxGroup.discriminatedValue === explicitTaxRate.discriminator) {
                                    // Loop through the sales taxs objects and match on id
                                    for (let j = 0; j < defaultTaxGroup.taxRates.length; j++) {
                                        const taxRate = defaultTaxGroup.taxRates[j];
                                        if (taxRate.id === explicitTaxRate.salesTax.id) {
                                            defaultTaxGroup.selectedTaxRate = taxRate;
                                            found = true;
                                            break;
                                        }
                                    }

                                    if (found) {
                                        break;
                                    }
                                }
                            }
                        });

                        $scope.taxGroups = defaultTaxGroups;
                    });
                } else {
                    $scope.taxGroups = defaultTaxGroups;
                }
		});
	};
	
	var getUpdatedTaxRates = function() {
		const updatedTaxRates = [];

		angular.forEach($scope.taxGroups, (taxGroup) => {
			if (taxGroup.selectedTaxRate) {
				// Build up and add to the array
				const updatedTaxRate = {};
				updatedTaxRate.countryIsoCode = taxGroup.countryIsoCode;
				updatedTaxRate.discriminatedValue = taxGroup.discriminatedValue;
				updatedTaxRate.taxRate = {id: taxGroup.selectedTaxRate.id};
				
				updatedTaxRates.push(updatedTaxRate);
			}
		});

		return updatedTaxRates;
	};
	
	getTaxRates();
}]);



// WEBPACK FOOTER //
// ./src/controllers/modal/taxRates.controller.js